module.exports = __webpack_public_path__ + "img/pic3.8c8017d6.png";